import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-22ac593d")
const _hoisted_1 = { class: "panel" }
const _hoisted_2 = { style: {"flex-grow":"1"} }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(">")
const _hoisted_4 = {
  key: 0,
  class: "panel-content"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_chevron = _resolveComponent("chevron")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["panel-heading", { collapsible: _ctx.collapsible, expanded: _ctx.expanded }]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
    }, [
      _createElementVNode("span", _hoisted_2, [
        _renderSlot(_ctx.$slots, "heading", {}, undefined, true)
      ]),
      (_ctx.collapsible)
        ? (_openBlock(), _createBlock(_component_chevron, {
            key: 0,
            style: {"flex-grow":"0"},
            class: _normalizeClass({ rotate: _ctx.expanded })
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["class"]))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.expanded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "content", {}, undefined, true)
        ]))
      : _createCommentVNode("", true)
  ]))
}